var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 176,
    viewBox: "0 0 600 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_1647)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 176,
    fill: "url(#paint0_linear_77_1647)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M563.211 126.89C562.188 132.381 556.869 136.073 551.587 134.258C541.246 130.707 531.85 124.732 524.213 116.773C514.231 106.371 507.759 93.1027 505.704 78.8328C503.65 64.5628 506.117 50.0077 512.759 37.2117C519.401 24.4158 529.884 14.0217 542.736 7.48928C555.588 0.956893 570.164 -1.38564 584.416 0.790693C598.668 2.96702 611.88 9.55288 622.197 19.6233C632.514 29.6937 639.417 42.7428 641.938 56.938C643.866 67.7975 643.154 78.9104 639.929 89.3568C638.281 94.6937 632.164 96.8141 627.125 94.4044C622.086 91.9948 620.07 85.9589 621.39 80.5318C622.98 73.997 623.21 67.1674 622.022 60.4739C620.241 50.44 615.361 41.2161 608.068 34.0978C600.776 26.9794 591.437 22.3242 581.363 20.7858C571.288 19.2475 560.986 20.9033 551.901 25.5208C542.816 30.1382 535.406 37.4853 530.711 46.5303C526.016 55.5752 524.272 65.8635 525.725 75.9503C527.177 86.0372 531.752 95.4157 538.808 102.769C543.515 107.674 549.168 111.514 555.384 114.081C560.547 116.213 564.234 121.399 563.211 126.89Z",
    fill: "url(#paint1_linear_77_1647)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.21095 126.89C2.18758 132.381 -3.13084 136.073 -8.41346 134.258C-18.7536 130.707 -28.1503 124.732 -35.7866 116.773C-45.7686 106.371 -52.2413 93.1027 -54.2958 78.8328C-56.3503 64.5628 -53.8833 50.0077 -47.2414 37.2117C-40.5994 24.4158 -30.1162 14.0217 -17.2639 7.48928C-4.41164 0.956893 10.164 -1.38564 24.4159 0.790693C38.6678 2.96702 51.88 9.55288 62.1969 19.6233C72.5138 29.6937 79.4172 42.7428 81.9375 56.938C83.8656 67.7975 83.1543 78.9104 79.9288 89.3568C78.281 94.6937 72.1638 96.8141 67.1248 94.4044C62.0858 91.9948 60.0697 85.9589 61.3903 80.5318C62.9803 73.997 63.2105 67.1674 62.0221 60.4739C60.2406 50.44 55.3609 41.2161 48.0683 34.0978C40.7757 26.9794 31.4366 22.3242 21.3625 20.7858C11.2885 19.2475 0.985619 20.9033 -8.09909 25.5208C-17.1838 30.1382 -24.594 37.4853 -29.2889 46.5303C-33.9838 55.5752 -35.7276 65.8635 -34.2753 75.9503C-32.8231 86.0372 -28.2478 95.4157 -21.192 102.769C-16.4852 107.674 -10.8322 111.514 -4.61603 114.081C0.546589 116.213 4.23431 121.399 3.21095 126.89Z",
    fill: "url(#paint2_linear_77_1647)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M564.946 68.7978C564.513 63.229 568.695 58.2863 574.267 58.6716C585.174 59.4258 595.797 62.7656 605.233 68.4762C617.567 75.9408 627.253 87.0814 632.931 100.333C638.609 113.585 639.993 128.283 636.889 142.362C633.786 156.441 626.35 169.194 615.626 178.83C604.902 188.467 591.43 194.502 577.1 196.088C562.771 197.675 548.304 194.733 535.732 187.676C523.16 180.619 513.115 169.801 507.007 156.742C502.333 146.751 500.144 135.833 500.556 124.908C500.767 119.326 506.127 115.695 511.618 116.718C517.108 117.742 520.618 123.05 520.747 128.634C520.903 135.358 522.448 142.014 525.328 148.172C529.646 157.403 536.747 165.05 545.633 170.038C554.52 175.026 564.745 177.106 574.874 175.984C585.003 174.863 594.527 170.597 602.107 163.785C609.687 156.974 614.943 147.959 617.137 138.007C619.331 128.056 618.352 117.667 614.339 108.299C610.325 98.932 603.479 91.0572 594.76 85.7808C588.944 82.2609 582.49 80.0154 575.821 79.1447C570.283 78.4215 565.378 74.3665 564.946 68.7978Z",
    fill: "url(#paint3_linear_77_1647)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.94571 68.7978C4.51304 63.229 8.69469 58.2863 14.2669 58.6716C25.1739 59.4258 35.7969 62.7656 45.2328 68.4762C57.567 75.9408 67.2532 87.0814 72.931 100.333C78.6088 113.585 79.9931 128.283 76.8893 142.362C73.7855 156.441 66.3496 169.194 55.626 178.83C44.9024 188.467 31.4297 194.502 17.1002 196.088C2.77062 197.675 -11.6959 194.733 -24.2678 187.676C-36.8396 180.619 -46.8851 169.801 -52.9935 156.742C-57.6665 146.751 -59.8557 135.833 -59.4438 124.908C-59.2334 119.326 -53.8734 115.695 -48.3825 116.718C-42.8915 117.742 -39.3819 123.05 -39.2529 128.634C-39.0974 135.358 -37.5521 142.014 -34.6718 148.172C-30.354 157.403 -23.2533 165.05 -14.3668 170.038C-5.48036 175.026 4.74542 177.106 14.8743 175.984C25.0033 174.863 34.5265 170.597 42.1066 163.785C49.6866 156.974 54.9427 147.959 57.1367 138.007C59.3306 128.056 58.3522 117.667 54.3388 108.299C50.3253 98.932 43.4786 91.0572 34.7601 85.7808C28.9441 82.2609 22.49 80.0154 15.8212 79.1447C10.2827 78.4215 5.37838 74.3665 4.94571 68.7978Z",
    fill: "url(#paint4_linear_77_1647)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 88,
    r: 65,
    fill: "#EF8A21"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_1647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 88,
    width: 44,
    height: 44,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 114.75C249.84 114.75 249.69 114.7 249.55 114.6C249.22 114.35 249.15 113.88 249.4 113.55C250.97 111.46 250.97 108.54 249.4 106.45C249.15 106.12 249.22 105.65 249.55 105.4C249.88 105.15 250.35 105.22 250.6 105.55C252.56 108.17 252.56 111.83 250.6 114.45C250.45 114.65 250.23 114.75 250 114.75Z",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83 117.25C251.67 117.25 251.52 117.2 251.38 117.1C251.05 116.85 250.98 116.38 251.23 116.05C253.9 112.49 253.9 107.51 251.23 103.95C250.98 103.62 251.05 103.15 251.38 102.9C251.71 102.65 252.18 102.72 252.43 103.05C255.5 107.14 255.5 112.86 252.43 116.95C252.29 117.15 252.06 117.25 251.83 117.25Z",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.02 101.78C244.9 101.16 243.47 101.32 242.01 102.23L239.09 104.06C238.89 104.18 238.66 104.25 238.43 104.25H237.5H237C234.58 104.25 233.25 105.58 233.25 108V112C233.25 114.42 234.58 115.75 237 115.75H237.5H238.43C238.66 115.75 238.89 115.82 239.09 115.94L242.01 117.77C242.89 118.32 243.75 118.59 244.55 118.59C245.07 118.59 245.57 118.47 246.02 118.22C247.13 117.6 247.75 116.31 247.75 114.59V105.41C247.75 103.69 247.13 102.4 246.02 101.78Z",
    fill: "#F7941E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_77_1647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 66,
    width: 44,
    height: 44,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5 86.19H305.61C303.24 86.19 301.31 84.26 301.31 81.89V79C301.31 78.45 300.86 78 300.31 78H296.07C292.99 78 290.5 80 290.5 83.57V92.43C290.5 96 292.99 98 296.07 98H303.93C307.01 98 309.5 96 309.5 92.43V87.19C309.5 86.64 309.05 86.19 308.5 86.19ZM300.28 91.78L298.28 93.78C298.21 93.85 298.12 93.91 298.03 93.94C297.94 93.98 297.85 94 297.75 94C297.65 94 297.56 93.98 297.47 93.94C297.39 93.91 297.31 93.85 297.25 93.79C297.24 93.78 297.23 93.78 297.23 93.77L295.23 91.77C294.94 91.48 294.94 91 295.23 90.71C295.52 90.42 296 90.42 296.29 90.71L297 91.44V87.25C297 86.84 297.34 86.5 297.75 86.5C298.16 86.5 298.5 86.84 298.5 87.25V91.44L299.22 90.72C299.51 90.43 299.99 90.43 300.28 90.72C300.57 91.01 300.57 91.49 300.28 91.78Z",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.43 84.81C306.38 84.82 307.7 84.82 308.83 84.82C309.4 84.82 309.7 84.15 309.3 83.75C307.86 82.3 305.28 79.69 303.8 78.21C303.39 77.8 302.68 78.08 302.68 78.65V82.14C302.68 83.6 303.92 84.81 305.43 84.81Z",
    fill: "#F7941E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_77_1647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 44,
    width: 44,
    height: 44,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 70.75C361.84 70.75 361.69 70.7 361.55 70.6C361.22 70.35 361.15 69.88 361.4 69.55C362.97 67.46 362.97 64.54 361.4 62.45C361.15 62.12 361.22 61.65 361.55 61.4C361.88 61.15 362.35 61.22 362.6 61.55C364.56 64.17 364.56 67.83 362.6 70.45C362.45 70.65 362.23 70.75 362 70.75Z",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.83 73.25C363.67 73.25 363.52 73.2 363.38 73.1C363.05 72.85 362.98 72.38 363.23 72.05C365.9 68.49 365.9 63.51 363.23 59.95C362.98 59.62 363.05 59.15 363.38 58.9C363.71 58.65 364.18 58.72 364.43 59.05C367.5 63.14 367.5 68.86 364.43 72.95C364.29 73.15 364.06 73.25 363.83 73.25Z",
    fill: "#F7941E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.02 57.78C356.9 57.16 355.47 57.32 354.01 58.23L351.09 60.06C350.89 60.18 350.66 60.25 350.43 60.25H349.5H349C346.58 60.25 345.25 61.58 345.25 64V68C345.25 70.42 346.58 71.75 349 71.75H349.5H350.43C350.66 71.75 350.89 71.82 351.09 71.94L354.01 73.77C354.89 74.32 355.75 74.59 356.55 74.59C357.07 74.59 357.57 74.47 358.02 74.22C359.13 73.6 359.75 72.31 359.75 70.59V61.41C359.75 59.69 359.13 58.4 358.02 57.78Z",
    fill: "#F7941E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_1647",
    x: 207.4,
    y: 75.4,
    width: 73.2,
    height: 73.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_1647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_1647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_77_1647",
    x: 263.4,
    y: 53.4,
    width: 73.2,
    height: 73.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_1647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_1647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_77_1647",
    x: 319.4,
    y: 31.4,
    width: 73.2,
    height: 73.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_1647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_1647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_1647",
    x1: 0,
    y1: 0,
    x2: 91.1101,
    y2: 311.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA7B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_77_1647",
    x1: 574,
    y1: 0,
    x2: 574,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_77_1647",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_77_1647",
    x1: 587.366,
    y1: 194.156,
    x2: 551.649,
    y2: 60.8585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_77_1647",
    x1: 27.3658,
    y1: 194.156,
    x2: -8.35126,
    y2: 60.8585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_1647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 176,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.40d25104197ac17ac43c1c3e64194c4c.svg";
export { ForwardRef as ReactComponent };